import { BUY, SELL } from '../model/OrderSide'
import { LONG, SHORT } from '../model/RequestType'

export const checkIsOpenRequest = (type, side) =>
  (type === SHORT && side === SELL) || (type === LONG && side === BUY)
